/**
 * main.ts
 *
 * Bootstraps Vuetify and other plugins then mounts the App`
 */

// Plugins
import { registerPlugins } from '@/infrastructure/plugins';
import { registerSentry } from '@/infrastructure/plugins/sentry';
import * as Sentry from '@sentry/vue';

// Components
import App from './App.vue';

// Composables
import { createApp } from 'vue';
import { sessionManager } from '@/services/sessionManagerInstance';
import { ensureSession } from '@/interfaces/composables/auth/auth';
import { authState } from '@/interfaces/composables/auth/authState';

async function bootstrap() {
  await sessionManager.initializeSession();
  await ensureSession();
  authState.hasCheckedAuth.value = true;

  // ✅ Now mount the app — UI will only see final state
  const app = createApp(App);
  registerSentry(app);
  registerPlugins(app);
  app.mount('#app');
}

bootstrap().catch((error) => {
  Sentry.captureException(error);
});